import { JSX } from 'react'
import { StepConfig } from '@Components/claim-form-flow/types'

export type ClaimFormHostConfig = {
  steps: StepConfig[]
  legalText: JSX.Element
  gameTypeHelp: {
    title: string
    content: JSX.Element
  }
  confirmation: {
    backgroundImage: string
    heroImage?: string
    title: string
    message: JSX.Element
  }
}

export type HostConfig = {
  standardFlowRangeInCents: {
    min: number
    max: number
  }
  playerInformation: {
    phoneConsentLabel: JSX.Element
    emailConsentLabel: JSX.Element
    agreeToTermsLabel: JSX.Element
    minAgeForPhoneVerification: number
    ageForVerificationError: string
  }
  reasonForVisitScreen: {
    prizeAmountDisclaimer: JSX.Element
  }
  bookableScreen: {
    header: string
    subHeader: string
  }
  confirmationScreen: {
    itemsNeeded: string[]
    disclaimer: JSX.Element
    additionalSections: JSX.Element[]
    claimFormSections?: (beginClaimForm: () => void) => JSX.Element[]
  }
  bigWinnerFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  damagedTicketFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  unknownWinFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  regularTicketFlow: {
    backgroundImage: string
    details: JSX.Element[]
  }
  manyTicketsFlow: {
    ticketThreshold: number
    backgroundImage: string
    details: JSX.Element[]
  }
  calendarEvent: {
    details: string
    title: string
  }
  claimFormConfig?: ClaimFormHostConfig
}

export enum HOST_NAMES {
  MSL = 'msl',
  GAMBYT_DEMO = 'gambyt-demo',
}
